var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
// components
import { A } from "core/Typography";
// components: Icons
import Instagram from "core/ReusableIcons/Instagram";
import Threads from "core/ReusableIcons/Threads";
import Facebook from "core/ReusableIcons/Facebook";
import Linkedin from "core/ReusableIcons/Linkedin";
import Spotify from "core/ReusableIcons/Spotify";
import Pinterest from "core/ReusableIcons/Pinterest";
// styles
import colors from "core/colors";
import { easingSeconds } from "core/animation";
import { convertPxToRem } from "frontend/components/helpers";
import { focusOutline } from "core/links";
var LinkStyled = styled(A)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: ", ";\n    height: ", ";\n    background-color: ", ";\n    border-radius: 50%;\n    border-bottom: none;\n    transition: background-color ", ";\n\n    &:hover {\n        background-color: ", ";\n        border-bottom: none;\n    }\n\n    &:focus {\n        outline: none;\n    }\n\n    &:focus-visible {\n        ", "\n    }\n"], ["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: ", ";\n    height: ", ";\n    background-color: ", ";\n    border-radius: 50%;\n    border-bottom: none;\n    transition: background-color ", ";\n\n    &:hover {\n        background-color: ", ";\n        border-bottom: none;\n    }\n\n    &:focus {\n        outline: none;\n    }\n\n    &:focus-visible {\n        ", "\n    }\n"])), convertPxToRem(34), convertPxToRem(34), colors.secondary.oolong, easingSeconds, colors.secondary.dolphin, focusOutline);
var SocialsStyled = styled.ul(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    gap: ", ";\n    margin-top: 1rem;\n"], ["\n    display: flex;\n    gap: ", ";\n    margin-top: 1rem;\n"])), convertPxToRem(8));
// data
var socialMedia = [
    {
        name: "Instagram",
        href: "https://www.instagram.com/nounproject",
        Icon: Instagram,
    },
    {
        name: "Threads",
        href: "https://www.threads.com/@nounproject",
        Icon: Threads,
    },
    {
        name: "Facebook",
        href: "https://www.facebook.com/thenounproject",
        Icon: Facebook,
    },
    {
        name: "Linkedin",
        href: "https://www.linkedin.com/company/noun-project/",
        Icon: Linkedin,
    },
    {
        name: "Spotify",
        href: "https://open.spotify.com/show/2czl85XW02Rtie1qUTEdIk?si=eeec8b4ef6b34d70",
        Icon: Spotify,
    },
    {
        name: "Pinterest",
        href: "https://www.pinterest.com/thenounproject/",
        Icon: Pinterest,
    },
];
var Socials = function () { return (_jsx(SocialsStyled, { children: socialMedia.map(function (link) {
        var name = link.name, href = link.href, Icon = link.Icon;
        return (_jsx("li", { children: _jsx(LinkStyled, { href: href, alt: "Noun Project ".concat(name), target: "_blank", children: _jsx(Icon, { title: "".concat(name, " logo"), fillColor: colors.primary.diamond, size: { width: 20, height: 20 } }) }) }, name));
    }) })); };
export default Socials;
var templateObject_1, templateObject_2;
